export const SLICE_SETTING_LAYOUT = 'SLICE_SETTING_LAYOUT'

export const LIST_SEAT = `${SLICE_SETTING_LAYOUT}/listSeat`
